import gsap from 'gsap';
import ScrollTrigger from 'gsap/src/ScrollTrigger';
import './../src-utilities/country';

gsap.registerPlugin(ScrollTrigger);

export default class Header {
	// Elements
	header = document.querySelector('.header');
	headerTop = document.querySelector('.header-toggle');
	headerWrapper = document.querySelector('.header-wrapper');
	navLinkContainer = document.querySelectorAll('.nav-item[data-nav]');
	linksContainer = document.querySelector('.links-container');
	toggleBtn = document.querySelector('.toggle-btn input');
	backBtn = document.querySelector('.back-btn');
	linksContainers = Array.from(
		document.querySelectorAll('.links-container > *'),
	)
		.map((dropdown) => {
			return { [dropdown.dataset.nav]: dropdown };
		})
		.reduce((previous, current) => {
			return (previous = { ...previous, ...current });
		});
	headerBackDropShadow = document.querySelector('.header-back-drop');
	hamburger = document.querySelector('.hamburger');
	currentActive;
	isDesktop;
	isMobile;
	constructor() {
		if (window.innerWidth >= 1091) {
			this.desktopInit();
			this.isDesktop = true;
		} else {
			this.mobileInit();
			this.isMobile = true;
		}
		window.addEventListener('resize', this.handleChangeWidth);
		this.handleModes();
		this.hideThemeBtn();
		this.headerBackDropShadow.addEventListener(
			'click',
			this.headerBackDropClick,
		);
		this.setHeaderHeight();
		this.backBtn.addEventListener('click', this.handleBack);
	}

	setHeaderHeight() {
		document
			.querySelector(':root')
			.style.setProperty(
				'--header-height',
				document.querySelector('header').clientHeight + 'px',
			);
	}

	// Hide toggle btn section on scroll on desktop
	hideThemeBtn() {
		// Add toggle for only desktop
		let toggleMatchMedia = gsap.matchMedia();
		toggleMatchMedia.add('(min-width: 1091px)', () => {
			gsap.to(this.header, {
				y: () => -this.headerTop.getClientRects()[0].bottom,
				scrollTrigger: {
					markers: false,
					trigger: 'body',
					start: 'top top',
					end: '+50px',
					scrub: 0.1,
				},
			});
		});
	}

	handleBack = () => {
		this.linksContainer.classList.remove('open-container');
		this.linksContainers[this.currentActive]?.classList.remove('show');
		this.currentActive = undefined;
	};

	handleModes() {
		let mode = localStorage.getItem('mode');
		let html = document.querySelector('html');
		if (mode === 'dark') {
			html.classList.remove('light-mode');
			html.classList.add('dark-mode');
			this.toggleBtn.parentElement.classList.toggle('checked');
			this.toggleBtn.click();
		}

		this.toggleBtn.addEventListener('click', () => {
			html.classList.toggle('light-mode');
			html.classList.toggle('dark-mode');
			this.toggleBtn.parentElement.classList.toggle('checked');
			localStorage.setItem(
				'mode',
				this.toggleBtn.checked ? 'dark' : 'light',
			);
		});
	}

	headerBackDropClick = () => {
		const activeItem = this.currentActive?.dataset.nav;
		this.header.classList.remove('header-open-desktop');
		this.currentActive?.classList.remove('active');
		this.linksContainers[activeItem]?.classList.remove('show');
		this.currentActive = undefined;
	};

	desktopInit() {
		this.setHeaderHeight();
		this.desktopDropDownLinkClickEvent('add');
		this.servicesTabsInit();
	}

	servicesTabsInit() {
		const tabBtns = document.querySelectorAll('.services-tab-btn');
		const panels = document.querySelectorAll('.services-panel');
		if (!tabBtns.length || !panels.length) return;

		tabBtns.forEach((btn) => {
			if (btn.dataset.tabListenerAttached) return;
			btn.dataset.tabListenerAttached = 'true';

			const switchTab = () => {
				const targetPlatform = btn.dataset.platform;
				tabBtns.forEach((b) => {
					b.classList.remove('active');
					b.setAttribute('aria-selected', 'false');
				});
				panels.forEach((p) => {
					p.classList.remove('active');
				});

				btn.classList.add('active');
				btn.setAttribute('aria-selected', 'true');
				const targetPanel = document.querySelector(
					`.services-panel[data-panel="${targetPlatform}"]`,
				);
				if (targetPanel) {
					targetPanel.classList.add('active');
				}
			};

			btn.addEventListener('click', switchTab);
			btn.addEventListener('mouseenter', switchTab);
		});
	}

	mobileInit() {
		this.setHeaderHeight();
		this.hamburger.addEventListener('click', this.hamburgerClick);
		this.navLinkContainer.forEach((element) => {
			element.addEventListener('click', this.navContainerClick);
		});
	}

	resetDesktop() {
		this.headerBackDropClick();
		this.desktopDropDownLinkClickEvent('remove');
	}

	resetMobile() {
		this.currentActive = undefined;
		this.hamburger.removeEventListener('click', this.hamburgerClick);
		this.navLinkContainer.forEach((element) => {
			element.removeEventListener('click', this.navContainerClick);
		});
	}

	desktopDropDownLinkClickEvent(eventType) {
		this.navLinkContainer.forEach((link) => {
			if (eventType === 'add')
				link.addEventListener('click', this.desktopDropDownClick);
			if (eventType === 'remove')
				link.removeEventListener('click', this.desktopDropDownClick);
		});
	}

	desktopDropDownClick = (event) => {
		const currentItem = event.currentTarget.dataset.nav;
		const previousItem = this.currentActive?.dataset.nav;

		// if click event is on same link
		if (previousItem === currentItem) {
			this.headerBackDropClick();
			return;
		}

		if (!this.header.classList.contains('header-open-desktop')) {
			this.header.classList.add('header-open-desktop');
		}

		this.currentActive?.classList.remove('active');
		event.currentTarget.classList.add('active');
		this.linksContainers[previousItem]?.classList.remove('show');
		this.linksContainers[currentItem].classList.add('show');
		this.currentActive = event.currentTarget;
	};

	hamburgerClick = (event) => {
		const isActive = event.currentTarget.classList.contains('active');
		event.currentTarget.classList.toggle('active');

		if (!isActive) {
			this.headerWrapper.classList.add('open-header');
			return;
		}
		this.linksContainer.classList.remove('open-container');
		this.linksContainers[this.currentActive]?.classList.remove('show');
		this.headerWrapper.classList.remove('open-header');
		this.currentActive = undefined;
	};

	navContainerClick = (event) => {
		const navItem = event.currentTarget.dataset.nav;
		this.linksContainer.classList.add('open-container');
		this.linksContainers[this.currentActive]?.classList.remove('show');
		this.linksContainers[navItem].classList.add('show');
		this.currentActive = navItem;
	};

	handleChangeWidth = () => {
		if (window.innerWidth >= 1091 && !this.isDesktop) {
			this.isDesktop = true;
			this.isMobile = false;
			this.resetMobile();
			this.desktopInit();
			this.currentActive = undefined;
		}

		if (window.innerWidth < 1091 && !this.isMobile) {
			this.isMobile = true;
			this.isDesktop = false;
			this.resetDesktop();
			this.mobileInit();
			this.currentActive = undefined;
		}
	};
}

// For Toggle of Service Section Inside Header below 1091px
document.addEventListener('DOMContentLoaded', function () {
	const headers = document.querySelectorAll('.flex-inner-head p');

	headers.forEach((header) => {
		header.addEventListener('click', function () {
			// Close all other dropdowns
			headers.forEach((h) => {
				if (
					h !== this &&
					h.parentElement.classList.contains('active')
				) {
					h.parentElement.classList.remove('active');
				}
			});

			// Toggle the clicked dropdown
			const parent = this.parentElement;
			parent.classList.toggle('active');
		});
	});

	// For Desktop Services Tab Switching
	const tabBtns = document.querySelectorAll('.services-tab-btn');
	const panels = document.querySelectorAll('.services-panel');
	if (tabBtns.length && panels.length) {
		tabBtns.forEach((btn) => {
			if (btn.dataset.tabListenerAttached) return;
			btn.dataset.tabListenerAttached = 'true';

			const switchTab = () => {
				const targetPlatform = btn.dataset.platform;
				tabBtns.forEach((b) => {
					b.classList.remove('active');
					b.setAttribute('aria-selected', 'false');
				});
				panels.forEach((p) => {
					p.classList.remove('active');
				});

				btn.classList.add('active');
				btn.setAttribute('aria-selected', 'true');
				const targetPanel = document.querySelector(
					`.services-panel[data-panel="${targetPlatform}"]`,
				);
				if (targetPanel) {
					targetPanel.classList.add('active');
				}
			};

			btn.addEventListener('click', switchTab);
			btn.addEventListener('mouseenter', switchTab);
		});
	}
});
// For Toggle of Service Section Inside Header below 1091px
